import React from 'react';
import classnames from 'classnames';

import { AppBar, Toolbar, Button, Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Translate } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  appBar: {
    top: 'auto',
    bottom: 0,
    zIndex: theme.zIndex.speedDial,
    backgroundColor: theme.palette.background.default
  },
  text: {
    color: theme.palette.common.black,
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  },
  container: {
    textAlign: 'end'
  },
  toolbar: {
    justifyContent: 'flex-end',
    marginLeft: 240,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0
    }
  },
  btn: {
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
      width: '100%'
    },
    boxShadow: theme.shadows[5],
    fontSize: theme.spacing(2),
    fontWeight: theme.typography.fontWeightSemibold,
    '&.Mui-disabled': {
      boxShadow: theme.shadows[3]
    }
  }
}));

interface AddKeywordsBarProps {
  keywords: string[]
  disabled: boolean
  handleClick: () => void
}

export default function AddKeywordsBar ({ keywords, disabled, handleClick }: AddKeywordsBarProps) {
  const classes = useStyles();

  return (
    <AppBar
      component='div'
      elevation={0}
      position='sticky'
      className={classes.appBar}
    >
      <Toolbar className={classes.toolbar}>
        <Container maxWidth='lg' className={classes.container}>
          {keywords.length > 0
            ? (
              <Translate
                content={keywords.length > 1 ? 'submit_keywords' : 'submit_keyword'}
                with={{ keywords: keywords.length }}
                className={classes.text}
              />
              )
            : <Translate content='enter_keywords' className={classes.text} />}
          <Button
            disabled={disabled}
            onClick={handleClick}
            variant='contained'
            color='primary'
            size='large'
            className={classnames(classes.btn, 'nr-confirm-add-keywords')}
          >
            {keywords.length > 0
              ? (
                <Translate
                  content={keywords.length > 1 ? 'add_number_keywords' : 'add_number_keyword'}
                  with={{ keywords: keywords.length }}
                />
                )
              : <Translate content='add_keyword' />}
          </Button>
        </Container>
      </Toolbar>
    </AppBar>
  );
}
